<crm-multi-select
  [filtersUiVersion]="filtersUiVersion"
  [styleClass]="styleClass + (isError ? ' ng-invalid ng-dirty' : '')"
  [class]="class + (isError ? ' ng-invalid ng-dirty' : '')"
  [label]="isFloatLabel ? selectLabel : ''"
  [showClear]="showClear"
  [appendTo]="appendTo"
  [options]="taskTypes"
  [disabled]="disabled"
  [display]="display"
  [sort]="sort"
  [placeholder]="placeholder"
  [(selectedItems)]="selectedTaskTypes"
  (selectedItemsChange)="onSelectedTaskTypesChange($event)"></crm-multi-select>
